export default "__VITE_ASSET__Bg_zrdka__"